export default __webpack_public_path__ + "55f2a3557a6f31172fe2f2a695b57b7a.png";